<template>
  <div
    class="flex grow items-center gap-2 overflow-hidden"
    :class="[{ 'cursor-not-allowed': disabled }, themeClasses]"
    role="button"
  >
    <div v-if="isSlotUsed" class="flex shrink-0"><slot name="icon" /></div>
    <div class="grow overflow-hidden truncate whitespace-nowrap">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { hasSlotContent } from '@klausapp/shared/utils/slot'
import { UiMenuItemTheme } from './types'

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    theme?: UiMenuItemTheme
  }>(),
  {
    theme: UiMenuItemTheme.Default,
  },
)

const slots = useSlots()

const isSlotUsed = computed(() => hasSlotContent(slots.icon))

const themeClasses = computed(() => {
  if (props.disabled) return disabledThemeClasses[props.theme]

  return activeThemeClasses[props.theme]
})

const activeThemeClasses = {
  [UiMenuItemTheme.Danger]: 'text-red-60',
  [UiMenuItemTheme.Default]: 'text-gray-80',
}

const disabledThemeClasses = {
  [UiMenuItemTheme.Danger]: 'text-red-40',
  [UiMenuItemTheme.Default]: 'text-gray-50',
}
</script>
